import React, { Component } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faUserPlus } from '@fortawesome/free-solid-svg-icons';
import SwalServices from '../../services/swalServices/SwalServices';
import AdminServices from '../../services/axiosServices/apiServices/adminServices';
import { Link, Navigate } from "react-router-dom";
import { encryptAES } from '../../utils/Encryption';
import ValidationText from '../../utils/validation/ValidationText';
import { CommonSuccessMessages, CommonValidationMessages } from '../../utils/Messages';
import { isValidForm } from '../../utils/validation/CommonValidator';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { ProgressSpinner } from 'primereact/progressspinner';

export default class Location extends Component {
    constructor(props) {
        super(props);
        this.swalServices = new SwalServices();
        this.adminServices = new AdminServices();
        this.state = {
            locationId: 0,
            locationList: [],
            globalFilter: '',
            dateRange: null,
            filterDetails: {
                start: 0,
                length: -1,
                search: '',
                roleId: '',
                sortField: '',
                sortOrder: 'asc',
                location: ''
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRules: {
                location: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace("{0}", "location name"),
                    },
                ],
            }
        };
    }

    componentDidMount() {
        this.getLocationList();
    }

    getLocationList = () => {
        let filterDetials = this.state.filterDetails;
        let request = [filterDetials.start, filterDetials.length, filterDetials.search, filterDetials.roleId, filterDetials.sortField, filterDetials.sortOrder];
        this.setState({ isLoading: true });
        this.adminServices.getLocationList(request).then((response) => {
            if (response && response.data && response !== null) {
                let res = response.data;
                this.setState({ locationList: res });
            }
            this.setState({ isLoading: false });
        });
    }

    actionBodyTemplate = (rowData) => {
        return (
            <div className="flex gap-2 justify-center">
                <Button
                    icon="pi pi-pencil"
                    className="p-button-rounded p-button-text p-button-sm"
                    style={{ width: '2rem', height: '2rem', padding: 0 }}
                    onClick={() => this.handleEdit(rowData)}
                    tooltip="Edit"
                    tooltipOptions={{ position: 'top' }}
                />
                <Button
                    icon="pi pi-trash"
                    className="p-button-rounded p-button-text p-button-sm"
                    style={{ width: '2rem', height: '2rem', padding: 0 }}
                    onClick={() => this.handleDelete(rowData)}
                    tooltip="Delete"
                    tooltipOptions={{ position: 'top' }}
                />
            </div>
        );
    };


    handleEdit = (rowData) => {
        if (rowData.locationid && rowData.locationid > 0) {
            let details = this.state.filterDetails
            details.location = rowData.locationname
            this.setState({ filterDetails: details, locationId: rowData.locationid })
        }
    };

    handleDelete = (rowData) => {
        if (rowData.locationid && rowData.locationid > 0) {
            this.swalServices.Confirm(
                "",
                ``,
                CommonSuccessMessages.Yes_Text,
                CommonSuccessMessages.No_Text,
                `Are you sure you want to delete ?`
            ).then((response) => {
                if (response === true) {
                    this.adminServices.deleteLocation(rowData.locationid).then((response) => {
                        if (response.success === 1) {
                            this.getLocationList();
                            this.swalServices.Success(response.msg)
                        } else {
                            this.swalServices.Error(response.msg)
                        }
                    });
                }
            })
        }
    };

    handleChange = (event, name) => {
        let value = event.target.value;
        let details = this.state.filterDetails;
        details[name] = value;
        this.setState({ filterDetails: details });
    };

    isValidAllFields = () => {
        let state = {
            location: this.state.filterDetails.location,
        }
        const newValidState = isValidForm(
            state,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    createLocation = () => {
        let isValidAllFields = this.isValidAllFields()
        if (isValidAllFields) {
            let details = this.state.filterDetails;
            let request = {}
            request.locationName = details.location;

            this.adminServices.createLocation(request).then((response) => {
                if (response.success === 1) {
                    let details = this.state.filterDetails
                    details.location = ''
                    this.setState({ filterDetails: details, locationId: 0 }, () => {
                        this.swalServices.Success(response.msg)
                        this.getLocationList()
                    })
                } else {
                    this.swalServices.Error(response.msg)
                }
                this.setState({ isLoading: false });
            });
        }
    }

    updateLocation = () => {
        let isValidAllFields = this.isValidAllFields()
        if (isValidAllFields) {
            let details = this.state.filterDetails;
            let request = {}
            request.locationName = details.location;

            this.adminServices.updateLocation(request, this.state.locationId).then((response) => {
                if (response.success === 1) {
                    let details = this.state.filterDetails
                    details.location = ''
                    this.setState({ filterDetails: details, locationId: 0 }, () => {
                        this.swalServices.Success(response.msg)
                        this.getLocationList()
                    })
                } else {
                    this.swalServices.Error(response.msg)
                }
                this.setState({ isLoading: false });
            });
        }
    }

    filterByDateRange = (createddate) => {
        const { dateRange } = this.state;

        if (!dateRange || !dateRange[0] || !dateRange[1]) return true;

        const created = new Date(createddate);
        const start = new Date(dateRange[0]);
        const end = new Date(dateRange[1]);

        start.setHours(0, 0, 0, 0);
        end.setHours(23, 59, 59, 999);

        return created >= start && created <= end;
    };

    render() {
        if (this.state.route != null) {
            return <Navigate to={this.state.route} />;
        }

        const filteredData = this.state.locationList.filter((row) =>
            this.filterByDateRange(row.createddate)
        );

        return (
            <div className='location-lists'
                style={{ height: "calc((100dvh / 0.85) - 45.8px)" }}
            >
                <div className='location-lists-inner h-full p-[30px] overflow-y-auto'>
                    <div className='title flex items-center justify-between mb-[10px]'>
                        <h1 className='text-[22px] m-0 font-semibold text-[#004AAD]' style={{ lineHeight: "30px" }}>Location list</h1>
                    </div>
                    <div className='location-add p-5 bg-white rounded-[16px]' style={{ border: "1px solid #DFDFDF" }}>
                        {this.state.locationId > 0 ?
                            <h2
                                className='text-[16px] font-semibold mt-0'
                            >
                                Edit location
                            </h2>
                            :
                            <h2
                                className='text-[16px] font-semibold mt-0'>
                                Add new location
                            </h2>
                        }
                        <div className='location-add-inner'>
                            <div className='input-grp !mb-0 col-span-2'>
                                <label>Location name:</label>
                                <input
                                    type='text'
                                    placeholder='Enter location'
                                    id='location'
                                    name='location'
                                    className={`${this.state.validState?.error?.location ? "error" : ""}`}
                                    value={this.state.filterDetails.location}
                                    onChange={(event) => this.handleChange(event, "location")}
                                />
                                <ValidationText error={this.state.validState.error.location} />
                            </div>
                            {this.state.locationId > 0 ?
                                <button
                                    onClick={() => this.updateLocation()}
                                    className='flex items-center gap-[5px] py-[5px] px-[10px] text-[14px] font-medium rounded-[5px] text-[#FFFFFF] bg-[#0077B6] hover:bg-[#3b82f6] border-0 mt-5'>
                                    <FontAwesomeIcon className='w-5 h-5' icon={faPlus} />
                                    Update location
                                </button>
                                :
                                <button
                                    onClick={() => this.createLocation()}
                                    className='flex items-center gap-[5px] py-[5px] px-[10px] text-[14px] font-medium rounded-[5px] text-[#FFFFFF] bg-[#0077B6] hover:bg-[#3b82f6] border-0 mt-5'>
                                    <FontAwesomeIcon className='w-5 h-5' icon={faPlus} />
                                    Save location
                                </button>
                            }
                        </div>
                    </div>
                    <div className='location-table p-5 bg-white rounded-[16px] mt-[20px]' style={{ border: "1px solid #DFDFDF" }}>
                        <div className='table-inner grid grid-cols-3 gap-5 items-end'>
                            <div className="input-grp !mb-0">
                                <label>
                                    Search
                                </label>
                                <InputText
                                    type="search"
                                    value={this.state.globalFilter}
                                    onChange={(e) => this.setState({ globalFilter: e.target.value })}
                                    placeholder="Search across all columns..."
                                />
                            </div>
                            {/* <div className="input-grp !mb-0">
                                <label>
                                    Filter by Date Range
                                </label>
                                <Calendar
                                    value={this.state.dateRange}
                                    onChange={(e) => this.setState({ dateRange: e.value })}
                                    selectionMode="range"
                                    placeholder="Select date range"
                                    dateFormat="dd-mm-yy"
                                    readOnlyInput
                                    numberOfMonths={2}
                                />
                            </div>
                            <Button
                                label="Reset filters"
                                className='w-fit h-fit'
                                onClick={() => this.setState({ globalFilter: '', dateRange: null })}
                            /> */}
                        </div>
                        <div className='sub-table rounded-xl shadow-sm overflow-hidden border border-gray-200 bg-white mt-[20px]'>
                            <DataTable value={filteredData}
                                paginator rows={50}
                                responsiveLayout="scroll"
                                scrollable
                                scrollHeight="calc((100dvh / 0.85) - 560px)"
                                className="min-w-full"
                                globalFilter={this.state.globalFilter}
                                filterFunction={this.filterByDateRange}
                                filterElement={this.dateRangeFilterTemplate}
                                emptyMessage="No data found"
                                loading={this.state.isLoading}
                                loadingIcon={
                                    <div className="flex justify-center items-center w-full py-4">
                                        <ProgressSpinner style={{ width: '40px', height: '40px' }} strokeWidth="4" />
                                    </div>
                                }
                            >
                                <Column
                                    field="locationid"
                                    header="SrNo"
                                    body={(rowData, options) => options.rowIndex + 1}
                                    filterPlaceholder="Search by ID"
                                    headerClassName="bg-blue-50 text-blue-800 font-medium" ></Column>
                                <Column field="locationname" header="Location name" sortable filterPlaceholder="Search by location" headerClassName="bg-blue-50 text-blue-800 font-medium" ></Column>
                                <Column
                                    field="createddate"
                                    header="Created Date"
                                    headerClassName="bg-blue-50 text-blue-800 font-medium"
                                    sortable filterPlaceholder="Search by ID"
                                />
                                <Column
                                    field="createdby"
                                    header="Created By"
                                    headerClassName="bg-blue-50 text-blue-800 font-medium"
                                    sortable filterPlaceholder="Search by ID"
                                />
                                <Column
                                    field="modifieddate"
                                    header="Updated Date"
                                    headerClassName="bg-blue-50 text-blue-800 font-medium"
                                    sortable filterPlaceholder="Search by ID"
                                />
                                <Column
                                    field="modifiedby"
                                    header="Updated By"
                                    headerClassName="bg-blue-50 text-blue-800 font-medium"
                                    sortable filterPlaceholder="Search by ID"
                                />
                                <Column
                                    header="Actions"
                                    body={this.actionBodyTemplate}
                                    style={{ textAlign: 'center', width: '10rem' }}
                                    headerClassName="bg-blue-50 text-blue-800 font-medium"
                                />
                            </DataTable>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
